import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  eyebrow?: string;
  description?: string;
  link?: { to: string; label: string };
}

export default function SectionHeading({ title, eyebrow, description, link }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="min-w-0">
        {eyebrow && (
          <p className="text-[11px] font-label tracking-[0.2em] text-primary-600 mb-1.5">{eyebrow}</p>
        )}
        <div className="flex items-center gap-2.5">
          <span className="block w-1 h-5 rounded-full bg-primary-600" />
          <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950 leading-none">
            {title}
          </h2>
        </div>
        {description && (
          <p className="mt-2 text-sm text-foreground-500 line-clamp-1">{description}</p>
        )}
      </div>
      {link && (
        <Link
          to={link.to}
          className="shrink-0 inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {link.label}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-sm" aria-hidden="true" />
          </span>
        </Link>
      )}
    </div>
  );
}